import { render, staticRenderFns } from "./saleLayOut.vue?vue&type=template&id=ff438048"
import script from "./saleLayOut.vue?vue&type=script&lang=js"
export * from "./saleLayOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports